import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from '@app/core/services/jwt.service';
import { BnNgIdleService } from 'bn-ng-idle';

@Component({
  selector: 'app-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss']
})
export class SessionExpiredComponent implements OnInit {

  
  constructor(
    private bnIdle: BnNgIdleService, 
    private _jwt: JwtService,
    public router: Router
    ) { }

  ngOnInit(): void {
    this.startCountdown();
  }

  private timeoutId: any;
  count: number = 30;

  startCountdown(): void {
    this.count = 30; 
    this.updateCountdown();
  }

  private updateCountdown(): void {
    this.timeoutId = setTimeout(() => {
      this.count--;

      if (this.count === 0) {
        this._jwt.onLogOut();
      } else {
        this.updateCountdown();
      }
    }, 1000);
  }

  stopCountdown(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      //console.log('Countdown stopped');
    }
  }

  ngOnDestroy(): void {
    this.stopCountdown();
  }

  stopIdle(){
    this.stopCountdown();
    this.bnIdle.startWatching(1800);
  }

  logOut(){
   // this.bnIdle.stopTimer();
    this._jwt.onLogOut();
  }

}
